import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { resetPassword } from '../../actions/login';
import { AuthPage } from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';
import { getAuthState } from '../../selectors';

class ForgotPasswordPage extends React.Component {
  static propTypes = {
    authState: PropTypes.object.isRequired,
    resetPassword: PropTypes.func.isRequired,
  };

  handleSubmit = () => {
    this.props.resetPassword(this.emailInput.value);
    this.emailInput.value = '';
  }

  render() {
    return (
      <AuthPage heading="Password Reset">
        <Box className="form" direction="column">
          <input type="text" placeholder="email" ref={(elem) => this.emailInput = elem} disabled={this.props.authState.isLoading}/>
          <div className="error">{this.props.authState.error}</div>
          <div className="message">
            {this.props.authState.error === false
              ? 'Please check your email to reset your password.'
              : null}
          </div>
          <div className="actions">
            <Button onClick={this.handleSubmit} primary submit isDisabled={this.props.authState.isLoading}>
              { this.props.authState.isLoading ?
                  <i className="fa fa-refresh fa-spin" style={{color: 'white'}}></i>
                :
               "Submit"
            }</Button>
          </div>
        </Box>
      </AuthPage>
    );
  }
}

export default connect((state) => ({
    authState: getAuthState(state),
  }),
  {resetPassword},
)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/PasswordResetPage/index.js